import { useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import { Heading } from 'src/components/atoms/heading/heading';

const NotFound = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found">
      <Heading size={1} content="Pagina non trovata" className="title" />

      <div className="mb-1 mt-1">Nessuna pagina trovata</div>

      <Button onClick={goToHome} size="sm" rounded="rounded-sm" color="primary" className="mt-1">
        Ritorna alla home
      </Button>
    </div>
  );
};

export default NotFound;
